import axiosInstance from '../../config/axiosConfig';
import { urlActivos } from '../../config/apiURL';
import { extractArray, extractDataObject } from '../utils/responseHelpers';

// Obtener todos los activos
export async function getActivos() {
  try {
    const response = await axiosInstance.get(urlActivos);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching activos:', error);
    throw error;
  }
}

//Obtener activos por empresa
export async function getActivosPorEmpresa(emp_codigo) {
  try {
    const response = await axiosInstance.get(`${urlActivos}/empresa/${emp_codigo}`);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching activos by company:', error);
    throw error;
  }
}

// Obtener activo por nombre
export async function getActivoPorNombre(activo) {
  try {
    const response = await axiosInstance.get(`${urlActivos}/nombre/${activo}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error fetching activo por nombre (${activo}):`, error);
    throw error;
  }
}

// Crear un nuevo activo
export async function createActivo(formulario) {
  try {
    const response = await axiosInstance.post(urlActivos, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error('Error creating activo:', error);
    throw error;
  }
}

// Cargar el catálogo base IESS para una unidad de la empresa seleccionada.
export async function cargarCatalogoIess({ emp_codigo, uni_codigo }) {
  try {
    const response = await axiosInstance.post(`${urlActivos}/catalogo-iess`, {
      emp_codigo,
      uni_codigo,
    });
    return extractDataObject(response);
  } catch (error) {
    console.error('Error loading IESS asset catalog:', error);
    throw error;
  }
}

// Actualizar un activo existente
export async function updateActivo(id, formulario) {
  try {
    const response = await axiosInstance.put(`${urlActivos}/${id}`, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error updating activo ${id}:`, error);
    throw error;
  }
}

// Eliminar un activo
export async function deleteActivo(id) {
  try {
    const response = await axiosInstance.delete(`${urlActivos}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error deleting activo ${id}:`, error);
    throw error;
  }
}

export async function addActivoUnidad(uni_codigo, act_codigo) {
  try {
    const response = await axiosInstance.post(`${urlActivos}/unidad`, {
      uni_codigo,
      act_codigo,
    });
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error adding unidad to activo ${act_codigo}:`, error);
    throw error;
  }
}

export async function actualizarUnidadDeActivo(act_codigo, uni_nombre, emp_codigo) {
  const response = await axiosInstance.post(`${urlActivos}/actualizar-unidad-activo`, {
    act_codigo,
    uni_nombre,
    emp_codigo,
  });
  return extractDataObject(response);
}
